import { useApiQuery, useApiMutation } from "../services/react-query";

export const useGetSystemSettings = () =>
  useApiQuery({
    queryOptions: { queryKey: ["systemSettings"] },
    fetchOptions: { url: "/system-settings", method: "GET" },
  });

// The public slice of the system settings, so non-sysAdmins can read the
// app-wide switches too.
export const useGetMobileMetadata = () =>
  useApiQuery({
    queryOptions: { queryKey: ["mobileMetadata"] },
    fetchOptions: { url: "/mobile/metadata", method: "GET" },
  });

export const useGetSystemSetting = (key) =>
  useApiQuery({
    queryOptions: { queryKey: ["systemSetting", key], enabled: !!key },
    fetchOptions: { url: `/system-settings/${key}`, method: "GET" },
  });

export const useUpdateSystemSetting = () =>
  useApiMutation({
    mutationOptions: { mutationKey: ["updateSystemSetting"] },
    fetchOptions: { url: `/system-settings`, method: "PUT" },
    invalidateQueryKeys: [
      ["systemSettings"],
      ["systemSetting"],
      ["mobileMetadata"],
    ],
    successMessage: {
      title: "System settings updated",
      color: "green",
    },
  });
